<template>
  <div />
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'
import { VISIT_STATES } from 'sdk-vue-telehealth-visit'
const { mapState } = createNamespacedHelpers('visitSession')
export default {
  name: 'GenerateTestSession',
  computed: {
    ...mapState({
      serverState: (state) => state.clientStateSnapshot
    })
  },
  watch: {
    serverState: {
      deep: true,
      handler () {
        // if session state is created then initiate
        if (this.serverState.visitState === VISIT_STATES.PENDING) {
          this.initiateTestSession()
        }
        // if videoSession exists then send message to above frame
        if (this.serverState.videoSessionInfo && this.serverState.videoSessionInfo.sessionId) {
          window.parent.postMessage(this.serverState.videoSessionInfo, '*')
        }
      }
    }
  },
  mounted () {
    this.createTestSession()
  },
  methods: {
    ...mapActions({
      connectToSession: 'visitSession/connectToSession',
      registerSession: 'visitSession/register'
    }),
    createTestSession () {
      const practiceUuid = this.$route.query.practiceUuid
      const practiceChannelId = `doc-${practiceUuid}`

      const startSessionPayload = {
        practiceUuid,
        practiceChannelId,
        isNetworkTestForPatient: true
      }

      this.registerSession(startSessionPayload).then((response) => {
        const channelId = response.data.channelId
        this.connectToSession({ store: this.$store, channelId: channelId })
      })
    },
    initiateTestSession () {
      this.$store.commit('visitSession/SET_STATE', {
        ...this.serverState,
        visitState: 'routed_session_initiated'
      })
    }
  }
}
</script>
